/* global require */
export default [
  {
    path: '/',
    component: resolve => require(['@/views/Layout/Layout.vue'], resolve),
    meta: {
      title: '首页',
      keepAlive: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '后台登录',
      keepAlive: false
    },
    component: resolve => require(['@/views/Login/Login.vue'], resolve)
  }
];
